import { NormalizedSupportPolicy } from 'src/graphql/entities/support-policy/support-policy.utils';
import { POLICY_CATEGORY_ESCALATION } from './policy-constants';
import { resolvePolicyCategory } from './policy-groups';

export const getSelectedCategoriesAfterConversationClose = (
  selectedCategories: string[],
): string[] =>
  selectedCategories.includes(POLICY_CATEGORY_ESCALATION) ? ['All'] : selectedCategories;

/**
 * Which category a deep link has to open. Resolved against the unfiltered set, so
 * it is known even while the filters are hiding the target card.
 */
export const getFocusTargetCategory = (
  policies: Pick<NormalizedSupportPolicy, 'id' | 'category'>[],
  focusPolicyId: string,
): string =>
  resolvePolicyCategory(policies.find((policy) => policy.id === focusPolicyId)?.category);

export interface ResolvePartnerIdInput {
  /** `undefined` means untouched; `null` means Global. */
  scopePartnerId?: number | null;
  siteAddressPartnerId?: number;
  conversationPartnerId?: number;
  fallbackPartnerId: number;
  isSitePartnerPending?: boolean;
}

/** An explicit scope pick outranks entity context; the caller drops the pick when the open entity changes. */
export const resolvePartnerId = ({
  scopePartnerId,
  siteAddressPartnerId,
  conversationPartnerId,
  fallbackPartnerId,
  isSitePartnerPending = false,
}: ResolvePartnerIdInput): number | undefined => {
  if (scopePartnerId !== undefined) {
    return scopePartnerId ?? fallbackPartnerId;
  }

  if (isSitePartnerPending) {
    return undefined;
  }

  // partnerId 0 is the platform partner, so these are undefined checks, not falsy ones
  if (siteAddressPartnerId !== undefined) {
    return siteAddressPartnerId;
  }
  if (conversationPartnerId !== undefined) {
    return conversationPartnerId;
  }

  return fallbackPartnerId;
};
